import React, { useState } from "react";
import { Paper, Typography, IconButton, useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2), // Adjust the position as needed
    left: "5%",
    transform: "translateX(-2.5%)",
    padding: 0,
    marginBottom: 0,
    zIndex: 1000, // Ensure it's above other content
    maxWidth: "95%",
    maxHeight: "200px",
    overflow: "auto",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const AlertBanner = ({ severity = "info", message, style }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(true); // State to control visibility

  // Function to handle close action
  const handleClose = () => {
    setOpen(false);
  };

  // Adjust styles based on severity using theme values
  const severityStyles = {
    color: theme.palette.text.primary,
    backgroundColor:
      theme.palette[severity]?.light || theme.palette.background.default,
  };

  if (!open) return null; // Don't render the component if it's not open

  return (
    <Paper className={classes.root} style={{ ...severityStyles, ...style }}>
      <Typography variant="body1">{message}</Typography>
      <IconButton
        className={classes.closeButton}
        size="small"
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
    </Paper>
  );
};

export default AlertBanner;
